<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>&nbsp;</h5>
				<a href="" id="sidebarMenuClose"><feather type="x" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<div v-if="properties.uid">
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id" class="has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
							<input type="email" class="form-control" :name="form.id" v-model.lazy="headerData[form.id]" :id="form.id" :placeholder="form.name">
						</div>
					</ul>
					<ul class="sidebar-nav" v-else-if="form.division === 'O'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == headerData[form.id]">{{form1.codeName}}</span></p>
							<p class="mg-b-0 text-left" v-else>{{headerData[form.id]}}</p>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
								<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="headerData[form.id]" class="custom-control-input" :checked="form1.codeCode == headerData[form.id]">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
							<p class="mg-b-0 text-left">{{headerData[form.id]}}</p>
						</div>
					</ul>
				</div>
				<div v-else>
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id" class="has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
							<input type="email" class="form-control" :name="form.id" v-model.lazy="headerData[form.id]" :id="form.id" :placeholder="form.name">
						</div>
					</ul>
					<ul class="sidebar-nav" v-else-if="form.division === 'O'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == headerData[form.id]">{{form1.codeName}}</span></p>
							<p class="mg-b-0 text-left" v-else>{{headerData[form.id]}}</p>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
								<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="headerData[form.id]" class="custom-control-input" :checked="form1.codeCode == headerData[form.id]">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id" class="has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
							<date-picker v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' :placeholder="form.name" :id="form.id" v-model.lazy="headerData[form.id]" aria-label="Search" ignoreReadonly/>
						</div>
					</ul>
				</div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components pd-b-0-f overflow-hidden">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">Detail</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} Detail</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<!-- <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-if="appButtonFlag" v-on:click="confirmData()"><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Confirm</button> -->
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="createData(true, 'create')"><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-if="properties.uid" v-on:click="deleteData()"><feather type="delete" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>delete</button>
                        <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="csvExport()"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>EXCEL</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="goPage()"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>List</button>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5 d-inline-block">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist"> <!-- 상단 tab (현재단계 / 이전단계검체 / Plate) -->
							<li class="nav-item"><a class="nav-link active" id="plating-tab" data-toggle="tab" href="#plating" role="tab" aria-controls="plating" aria-selected="true" @click="this.rendertab">Result</a></li>
							<!-- <li class="nav-item"><a class="nav-link" id="samples-tab" data-toggle="tab" href="#samples" role="tab" aria-controls="samples" aria-selected="false">Samples</a></li> -->
						</ul>
					</div>
					<div class="card card-body pd-b-0-f">
						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="plating" role="tabpanel" aria-labelledby="plating-tab">
								<div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.checkAll"><feather type="check" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>all checked</a>
									<!-- <download-excel class = "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" :title="excelTitle" :data="excelData" :fields="excelHeader" worksheet = "My Worksheet" name = "SampleSheet.csv" type="csv">Sample Sheet</download-excel> -->
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-if="this.subName === 'IncroB'" @click="dialogHandler('confirm')"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>confirm</a>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="dialogHandler('report')"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>report</a>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.sampleDelColumn"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>delete</a>
								</div>
								<ul class="nav nav-line" id="myTab5" role="tablist"><!-- 현재 단계 검체 확인 tab (이전단계검체 / 현재단계) -->
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="properties.mid === form.id"><a class="nav-link active" @click='classifySampleHeader' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
									<li class="nav-item" v-else><a class="nav-link"  @click='classifySampleHeader' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
								</ul>
								<hot-table id='sample-table' :settings="sheetSettings" :data="sampleData" class="ht-hot-table zero-index" ref="sheet" :afterChange="changeData"></hot-table>
							</div><!-- tab -->
						
						</div>
					</div><!-- card -->
				</div>
			</div>
		</div>
		<div class="modal fade" id="modal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel5" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered chat-width" role="document">
				<div class="modal-content tx-14 chat-height">
					<div class="modal-header">
					<h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
					<div class="modal-body">
						<Chat></Chat>
					</div>
				</div>
			</div>
		</div><!-- chat modal -->

		 <v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="reportDialog"
                    max-width="500px"
					scrollable
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-card-title>
                            Download Report
                            </v-card-title>
                            <v-card-text style="max-height: 300px;">
								<li v-for="(item, index) in sampleData" v-if="item[0]">{{item[sampleNoIdx]}}</li>
                            <!-- <v-select
                                v-model="reportType"
                                :items="select[this.properties.task]"
                                label="A Select Report Type"
                                item-value="text"
                            ></v-select> -->
							<!-- {{this.subName}} Report -->
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                @click="reportDialog = false"
                            >
                                Close
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="createReport()"
                            >
                                Load
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div>
        </v-app>
	</div> <!-- this body end -->
</template>
<script>
	// 에디트 기능 handsontable 사용 시 임포트
	import Handsontable from 'handsontable';
	import {HotTable} from '@handsontable/vue';
	import 'handsontable-key-value';
	// 공통 함수 관리 파일 임포트
	import common from '@/views/Common/common.js';
	// 멀티 드래그 앤 드롭 임포트
	import Sortable, {Swap} from 'sortablejs';
	Sortable.mount(new Swap());
	// Header의 메뉴 정보 호출을 위한 bus event
	import {bus} from '../../main';
	import Chat from "@/views/Common/Chat";

	// 이미지 드래거블
	import { Draggable } from 'draggable-vue-directive'

	// 달력 관련 
	import datePicker from "vue-bootstrap-datetimepicker";
	import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
	import moment from "moment";

	// 경고창, 컨펌창
	import { Buefy } from 'buefy';
	export default {
		name: 'Detail',
		props: ['properties'],
		directives: {Draggable,},
		data(){
			return{
				reportDialog: false,
				reportType:'',
				select: {
					"GutMorning": 
						[
							{ text: 'GutMorning' },
							{ text: 'GutMorning-ildong' },
							{ text: 'Geninus' },
							{ text: 'Geninus-resized' },
							{ text: 'Geninus-xlsx' },
							{ text: 'Geninus-fastq(merged)' },
							{ text: 'Geninus-fastq(paird,woPrimer)' },
							{ text: 'Mediage' },
							{ text: 'The Clinic' },
						]
				},
				// date setting
				datePickerOptions: {
					format: "YYYY-MM-DD",
					useCurrent: false,
					showTodayButton: true,
					keepInvalid: false,
					ignoreReadonly: true
				},
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
				menuStatus: '',

				mid:'', // menu list id
				msid:'', // menu sheet id
				uid:'', // sheet id
				ssid:'', // sample list id
				rowNum:'', // sample group row number
				re_expid: '',
				premid: '',

				/* Plating input Form */
				resultHeader:[], // 입력 값 header column
				inputSearchForms:[], // 입력 input form
				dateSearchForms:[], // 입력 date form
				checkboxSearchForms:[], // 입력 radio form

				/* Plating 정보 Form Value */
				headerData: [], // 실험 정보 확인
				defaultHeaderData: [], // 화면에 처음 접속 시 유지된 실험 정보 (데이터 저장 시 수정 사항 체크에 필요)

				/* tab Header */
				tabHeader:[],
				// sheetCoulumns:[],

				/* 이전 단계 Sample 정보 */
				preHeader:[],
				preData:[],
				preDefaultData:[],
				preSampleHeader:[],
				preSampleData:[],
				preDefaultSampleData:[],
				preDetail:[],
				checkedRows:[], // 그룹 체크 row 확인
				checkedRowData:[], // add 이전 체크 sample row 확인
				sampleCheckedRows:[], // sample 체크 row 확인
				isEmpty: false,
				addData:[],
				defaultOpenedDetails:[],
				
				/* 데이터 변경 여부 sample add 등 Handsontable에 행위가 없어도 저장할 수 있도록 */
				isWork: 0,

				/* Sample Form */
				sampleHeader:[], // Plating Sample Header
				sampleData:[], // Plating Sample list data
				// sampleData:[1,2,3,4,5,6,7,8,9,10],
				
				dafaultSampleData:[], // 화면에 처음 접속 시 유지된 Sample 정보 (데이터 저장 시 수정 사항 체크에 필요)
				sampleChangeData:[], // Sample의 변경 정보
				boolChange: false, // 데이터 변경 유무 확인
				preDetail:[],

				/* Well Plate index */
				well_column:12,
				well_row:8,
				well_row_a:['A','B','C','D','E','F','G','H'],
				well_data:[],

				/* Loading */
				isLoading: false,
				isFullPage: true,
                appButtonFlag : true,
                isCheckAll: false,
                
				json_meta: [[{'key': 'charset','value': 'utf-8'}]],

				/* file upload */
				formData:'',
				uploadFlag: false,
				uFlag: false,
				pasteFlag: false,
				pasteCount:0,
				pasteForm: new FormData,

				/*idx */
				maxDivIdx:[],
				maxReIdx:[],
				maxIdx: [],

				userData:{},

				readonlyRow: [],

				width: 0,
				height: 0,
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
			window.removeEventListener("scroll", this.onScroll);
		},
		created(){
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyHeader();
				this.classifySampleHeader();
				this.classifyData();
				// this.classifyPreDefaultData();
            });
            bus.$on('userinfo', (data)=>{
                this.userData = data;

				if (data.official == 'CC069') {
					this.appButtonFlag = true;
				}
			});
				window.addEventListener('resize', this.handleResize);
			this.handleResize();
			
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
			this.$nextTick(function (){
				$("#gelimage").draggable();
			});
			window.addEventListener("scroll", this.onScroll);

		},
		components: {
			HotTable,
			Chat,
			datePicker,
			moment,
		},
		methods: {
			handleResize() {
				this.width = window.innerWidth;
				this.height = window.innerHeight;
			},
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				
				this.msid = data[2];
				this.resultHeader = data[3];
				this.menuStatus = data[4];

				//이전 단계 제거
				// let pJobOrder = 0;
				// for (let i in this.menuData) {
				// 	for (let j in this.menuData[i].subs) {
				// 		if (this.menuData[i].subs[j].id == this.properties.mid) {
				// 			pJobOrder = this.menuData[i].subs[j].jobOrder;
				// 		}
				// 	}
				// }
				// if (pJobOrder > 0) {
				// 	for (let i in this.menuData) {
				// 		this.menuData[i].subs = this.menuData[i].subs.filter(item => item.jobOrder != Number(pJobOrder-1));
				// 	}
				// }

				// this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);
				let tabs = common.resultTabs(this.properties.mid, this.menuData);

				// let currentMenu = {};
				// for (let i of this.menuData) {
				// 	for (let j of i.subs) {
				// 		if (j.id == this.properties.mid) {
				// 			currentMenu = j;
				// 		}
				// 	}
				// }
				// for (let i of this.menuData) {
				// 	for (let j of i.subs) {
				// 		for (let k = currentMenu.jobOrder-2; k > 0; k--) {
				// 			if (j.jobOrder == k) {
				// 				// if (currentMenu.jobOrder == k && currentMenu.mid == j.id) {
				// 				// 	console.log(j.menuName)
				// 				// } else {
				// 				tabs.push(j);
				// 					console.log(j.menuName)
				// 				// }
				// 			}
				// 		}
				// 	}
				// }
				// tabs.push(currentMenu);
				this.tabHeader = tabs;
				//전단계 (microbiome) 보여줄 필요 없음 삭제
				// let tab = this.tabHeader.splice(this.tabHeader.length-2, 1);

				this.inputSearchForms = [];
				this.dateSearchForms = [];
				this.checkboxSearchForms = [];

				for(let i in this.resultHeader){
					if(this.resultHeader[i].columnType == "LIST"){
						if(this.resultHeader[i].columnAttr =='statecode'){
							this.inputSearchForms.push({'name':this.resultHeader[i].columnName, 'value':this.resultHeader[i].code, 'id':this.resultHeader[i].columnCode ,'division':'O', 'attr':this.resultHeader[i].columnAttr});
						}else{
							this.checkboxSearchForms.push({'name':this.resultHeader[i].columnName, 'id':this.resultHeader[i].columnCode, 'value':this.resultHeader[i].code, 'division':this.resultHeader[i].columnDivision, 'attr':this.resultHeader[i].columnAttr});
						}
					}else if(this.resultHeader[i].columnType == "DATE"){
						if(!common.isNull(this.properties.uid)){
							this.dateSearchForms.push({'name':this.resultHeader[i].columnName, 'value':'', 'id':this.resultHeader[i].columnCode, 'division':this.resultHeader[i].columnDivision, 'attr':this.resultHeader[i].columnAttr});
						}else{
							if(this.resultHeader[i].columnDivision == 'C'){
								this.dateSearchForms.push({'name':this.resultHeader[i].columnName, 'value':'', 'id':this.resultHeader[i].columnCode, 'division':this.resultHeader[i].columnDivision, 'attr':this.resultHeader[i].columnAttr});
							}
						}
					}else if(this.resultHeader[i].columnType == "COUNT"){
					}else if(this.resultHeader[i].columnType == "PIPELINE"){
						if(this.resultHeader[i].columnAttr =='pipeline'){
							this.inputSearchForms.push({'name':this.resultHeader[i].columnName, 'value':this.resultHeader[i].code, 'id':this.resultHeader[i].columnCode ,'division':'O', 'attr':this.resultHeader[i].columnAttr});
						}else{
							this.checkboxSearchForms.push({'name':this.resultHeader[i].columnName, 'id':this.resultHeader[i].columnCode, 'value':this.resultHeader[i].code, 'division':this.resultHeader[i].columnDivision, 'attr':this.resultHeader[i].columnAttr});
						}
					}else{
						if(this.resultHeader[i].columnName == 'No'){
						}else{
							if(!common.isNull(this.properties.uid)){
								this.inputSearchForms.push({'name':this.resultHeader[i].columnName, 'value':'', 'id':this.resultHeader[i].columnCode, 'division':this.resultHeader[i].columnDivision, 'attr':this.resultHeader[i].columnAttr});
							}
							else{
								if(this.resultHeader[i].columnDivision == 'C'){
									this.inputSearchForms.push({'name':this.resultHeader[i].columnName, 'value':'', 'id':this.resultHeader[i].columnCode, 'division':this.resultHeader[i].columnDivision, 'attr':this.resultHeader[i].columnAttr});
								}
							}
						}
					}
				}
			},
			/*
			* Load Headers & Samples Data
			*/
			async classifyData(){
				this.openLoading();
				var thisData = [];
				var sampleData = [];
				if(!common.isNull(this.properties.uid)){
					var params = [];
					params = {'ssid' : this.ssid};
					params['uid'] = this.properties.uid;
					var request = {params : params};

					await this.$axios.get(this.$apiHost + '/results/detail', request)
					.then(res=>{
						this.headerData = res.data;
						for(let i in res.data) this.defaultHeaderData[i] = res.data[i]; // 불필요한 저장을 방지 하기 위하여 처음 불러온 데이터를 배열에 넣어준다 (key:value)
					}).catch(err=>{console.log(err)});
					sampleData = this.headerData.samples;
					// sampleData = common.makeData(this.headerData.samples, 0);
					this.excelData = common.makeData(this.headerData.samples, 1);
                    
					for (let i in sampleData) {
						this.maxDivIdx.push(sampleData[i].maxdividx);
						this.maxReIdx.push(sampleData[i].maxreidx);
						sampleData[i].No = Number(i) + 1;
						thisData = thisData.concat(false);
						for(let j in this.sampleHeader){
							if (j == 0) {
								thisData = thisData.concat(sampleData[i].No);
								thisData = thisData.concat(sampleData[i].sampleId);
							}
							if(this.sampleHeader[j].columnType === 'LIST') {
								if(this.sampleHeader[j].mid != this.properties.mid){
									if(!common.isNull(sampleData[i][this.sampleHeader[j].columnCode])){
										for(let k in this.sampleHeader[j].code){
											if(sampleData[i][this.sampleHeader[j].columnCode] === this.sampleHeader[j].code[k].codeCode){
												thisData = thisData.concat(this.sampleHeader[j].code[k].codeName);
											} 
										}
									}else{
										thisData = thisData.concat('');
									}
								}else{
									thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
								}
							}else{
								if (this.sampleHeader[j].columnAttr === 'receptionno') {
									thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
								} else {
									thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
								}
							}
						}

						this.sampleData.push(thisData);
						this.dafaultSampleData.push(thisData);
						thisData = [];
					}
				}
				this.rendertab();
				this.isLoading = false;
            },
			/*
			* Previous Group Header
			*/
			async classifyPreHeader(tabbool){
				let mid = '';
				if(common.isNull(this.re_expid)){
					if(!common.isNull(event.target.id)){
						if(event.target.id === this.properties.mid) mid = this.properties.mid;
						else mid = common.preMid(this.properties.mid, this.menuData);
					}else{
						if(this.re_expid.length > 0) mid = this.re_expid;
						else mid = common.preMid(this.properties.mid, this.menuData);
					}
				}else{
					if(this.re_expid === this.properties.mid) mid = this.properties.mid;
					else mid = common.preMid(this.properties.mid, this.menuData);
				}
				// this.preHeader.splice(0, this.preHeader.length); // splice 로 삭제할 경우 vue 이벤트 처리는 되지만, 상속한 부모 배열 값 까지 모두 제거되는 문제가 생긴다.
				this.preHeader = [];
				if(tabbool) this.$refs.table.newColumns.splice(0, this.$refs.table.newColumns.length);
				this.preHeader = common.menuHeader(mid, this.menuData)[3];
				this.classifyPreData();
			},
			/*
			* Previous Group Data
			*/
			async classifyPreData(){
				this.preData = [];
				this.preData = common.makeData(this.preDefaultData, 1, this.addData); // {data, (0: code, 1:name), checkdata}
				for (let i in this.preData) {
					for (let j in this.preHeader) {
						if (this.preHeader[j].columnName === 'Total' && this.preHeader[j].columnType === 'COUNT') {
							this.preData[i][this.preHeader[j].columnCode] = this.preData[i].samples.length;
						}
					}
				}
			},
			/*
			* Previous Sample Header
			*/
			async classifyPreSampleHeader(){
				let tempPreheader = [];
				let mid = '';
				if(!common.isNull(event.target.id)){
					mid = event.target.id.replace(/[0-9]/g, "");
				}else {
					mid = common.preMid(this.properties.mid, this.menuData);
				}
				

				if(mid.length === 0){
					if(common.isNull(this.re_expid)) {
						mid = common.preMid(this.properties.mid, this.menuData);
					}else {
						mid = this.re_expid;
					}
				}else{
					// mid = common.preMid(this.properties.mid, this.menuData);
 					mid = event.target.id;
				}

				if(!common.isNull(mid)){
					this.preSampleHeader = [];
					if(common.isNull(this.re_expid)) tempPreheader = common.makeHeader(common.preMid(this.properties.mid, this.menuData), this.menuData,2)[1];
					else tempPreheader = common.makeHeader(this.re_expid, this.menuData,2)[1];

					this.preHeader.forEach(a=>{
						tempPreheader.some((b, c)=>{
							if(a.columnCode == b.columnCode) delete tempPreheader[c];
						});
					});

					for(let i in tempPreheader){
						if(i == 0) this.preSampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
						if(tempPreheader[i].columnAttr == 'receptionno') this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
						if(mid === tempPreheader[i].mid){
							if(tempPreheader[i].columnAttr != 'receptionno') this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
						}
						if(common.isNull(tempPreheader[i].mid)) this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
					}
				}
				this.classifyPreSampleData();
			},
			/*
			* Previous Sample Data
			*/
			async classifyPreSampleData(){
				let rowNum = event.target.id.replace(/[0-9]/g, "");
				if(rowNum.length === 0){
					if(!common.isNull(event.target.id)){
						rowNum = event.target.id;
						this.rowNum = rowNum;
					}else{
						rowNum = this.rowNum;
					}
				}else{
					rowNum = this.rowNum;
				}
				this.preDefaultSampleData = common.thisZeroDataSplice(this.preDefaultSampleData);
				this.preSampleData = [];
				this.preSampleData = common.makeData(this.preDefaultSampleData[rowNum], 1, this.addData); // {data, (0: code, 1:name), checkdata}
				for (let i in this.preSampleData) { //샘플탭 샘플 상세보기에 넘버링 값 추가
						this.preSampleData[i].no = Number(i) + 1;
				}
				if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[rowNum])){
					this.sampleCheckedRows = this.preSampleData;
				}else{
					this.sampleCheckedRows = [];
				}
			},
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifyPreDefaultData(tabbool){
				this.openLoading();
				let mid = '';
				let reexp = '';
				if(common.isNull(this.re_expid)){
					if(!common.isNull(event.target.id)){
						if(event.target.id === this.properties.mid) mid = common.nextMid(this.properties.mid, this.menuData);
						else mid = this.properties.mid;
					}else{
						if(this.re_expid.length > 0) mid = this.re_expid;
						else mid = this.properties.mid;
					}
				}else{
                    if(this.re_expid === this.properties.mid) {
						mid = common.nextMid(this.properties.mid, this.menuData);
						reexp = 'r';
					} else  {
						mid = this.properties.mid;
					}
				}
				this.preDefaultData = [];
				this.preSampleData = [];
				this.preDefaultSampleData = [];
				this.defaultOpenedDetails = [];
                var params = [];
				params = {'mid' : mid, reexp: reexp};
				// params = {'mid' : mid};
                var request = {params : params}
				await this.$axios.get(this.$apiHost + '/platinges/prestep', request)
				.then(res=>{
					for(let i in res.data){
						res.data[i].no = Number(i)+1;
						this.preDefaultData.push(res.data[i]);
						for(let j in res.data[i].samples){
							this.preDetail[res.data[i].samples[j].sampleId] = res.data[i].samples[j].duid;
							res.data[i].samples[j].gid = res.data[i].id;
						}
						this.preDefaultSampleData.push(res.data[i].samples);
					}
				}).catch(err=>{console.log(err)})
                // 이전 단계 (실험 대상), 현재 단계 (재실험 대상)에 배열에 데이터 세팅
				if(mid === this.properties.mid){
					// 이전 단계 (실험 대상 조화 - 결과가 PASS 만 조회)
					this.preDefaultSampleData = common.remove_default_sample(mid, this.menuData, this.preDefaultSampleData, '');
					this.preDefaultData = common.remove_default(this.preDefaultData);
				}else{
					// 현재 단계 (재실험 대상 조회 - 결과가 없고 R > 0 만 조회)
					this.preDefaultSampleData = common.remove_default_sample(mid, this.menuData, this.preDefaultSampleData, 'R');
                    this.preDefaultData = common.remove_default(this.preDefaultData);
				}
				if(tabbool) this.classifyPreHeader(tabbool);
				else this.preSetting();
				this.isLoading = false;
			},
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifySampleHeader(){
				let thisMid = event.target.id;
				if(common.isNull(thisMid)) thisMid = this.properties.mid;
				let data = common.makeResultHeader(this.properties.mid,this.menuData, 2);
				this.ssid = data[0];
				this.sampleHeader = data[1];

				this.sampleHeader.push()
				this.sheetSettings.hiddenColumns.columns = [2];
				this.$refs.sheet.settings.columns = [];
				this.$refs.sheet.settings.colHeaders = [];
				let idx = 3; // column hidden 을 위한 값

				for(let i in this.sampleHeader){
					if(Number(i) === 0){
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("");
						this.$refs.sheet.settings.columns.push({sampleData:'checkbox', type:'checkbox', width:'20px'});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('No');
						this.$refs.sheet.settings.columns.push({sampleData:'No', type:'text', readOnly: true, width:'30px'});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('id');
						this.$refs.sheet.settings.columns.push({sampleData:'id', type:'text', width:'20px', readOnly: true});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
						if(this.sampleHeader[i].columnAttr === 'receptionno') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, renderer: this.anchorRenderer, readOnly: true});
						else this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
					}else{
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
						if(this.sampleHeader[i].columnType === 'LIST'){
							var source = [];
							for(let j in this.sampleHeader[i].code){
								if (j == 0) {
									source.push({id:null, name:''});
								}
								source.push({id:this.sampleHeader[i].code[j].codeCode, name:this.sampleHeader[i].code[j].codeName});
							}
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
								}
							}else{
								this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'key-value', filter:false, source: source, keyProperty: 'id', valueProperty: 'name',});
							}
						}else if(this.sampleHeader[i].columnType === 'DATE'){
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}
							}else{
								this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'date', dateFormat:'YYYY-MM-DD'});
							}
						} else if (this.sampleHeader[i].columnType === 'FIGURE') {
							this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', renderer: this.figureRenderer});
						} else if (this.sampleHeader[i].columnType === 'PIPELINE') {
							this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'key-value', filter:false, source: this.pipeline, keyProperty: 'id', valueProperty: 'name',});
						} else {
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}else{
									if(this.sampleHeader[i].columnAttr === 'sampleid') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}
							}else{
								if (this.sampleHeader[i].columnDivision == 'O') {
									if (this.sampleHeader[i].columnName == 'Institute') {
										this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: false});
									} else {
										this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
									}
								} else {
									if(this.sampleHeader[i].columnAttr === 'plate') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
									else this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text'});
								}
							}
						}
					} 
					if(i > 0){
						if(thisMid != this.sampleHeader[i].mid){
							if(!common.isNull(this.sampleHeader[i].mid)){
								// 실험 내 화면에서 탭 선택 시 Handsontable column 숨기기 할 것
								this.sheetSettings.hiddenColumns.columns.push((Number(i)+Number(idx)));
							}
						}
					}
					// this.excelHeader[this.sampleHeader[i].columnName] = this.sampleHeader[i].columnCode;
				}
				this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('did');
				this.$refs.sheet.settings.columns.push({sampleData:'detailId', type:'text', readOnly: true});
				
				this.sheetSettings.hiddenColumns.columns.push(Number(this.$refs.sheet.settings.columns.length)-1);
				this.rendertab();

				let sampleNoColumn = this.sampleHeader.find(item => item.columnAttr == 'sampleid');
				this.sampleNoIdx = this.$refs.sheet.settings.columns.findIndex(item => item.sampleData == sampleNoColumn.columnCode);

			},
			/*
			* Sample Add Column
			*/
			async sampleAddColumn() {
				this.openLoading();
				let insert_row = [];
				let remove_row = [];
				if(this.addData.length > 0){
					this.checkedRowData.forEach((a,b)=>{
						insert_row.push(common.makeHeaderData(this.preDefaultData, a, a.gid));
					});
					common.a_overlap_c(this.addData);
					this.addData.forEach(a=>{
						insert_row.some((c,d)=>{
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									remove_row.push(d);
									return true;
								}
							}else{
								if(a.sampleId === c.sampleId){
									remove_row.push(d);
									return true;
								}
							}
						});
					});
					remove_row.sort((a,b)=>{ return b - a;});
					remove_row.forEach(a=>{
						insert_row.splice(a,1);
					});
					insert_row.forEach(a=>{
						this.addData.push(a);
					});
				}else{
					this.checkedRowData.forEach((a,b)=>{
						insert_row.push(common.makeHeaderData(this.preDefaultData, a, a.gid));
						this.addData.push(a);
					});
				}
				let detailHeader = common.menuHeader(this.properties.mid, this.menuData, 2)[3];
				if(this.re_expid === this.properties.mid){
					insert_row.forEach(a=>{
						detailHeader.forEach(b=>{
							a[b.columnCode] = '';
							// console.log(b.columnName, b.columnCode, b.columnAttr, a[b.columnCode])
						});
					})
				}
				// 위에서 만든 insert_row를 sampleHeader(Plating 테이블 헤더) 순서에 맞춰 Handsontable에 데이터를 넣어준다
				// ref는 검색을 통하면 어떠한 기능인지 확인 가능
				// Handsontable 은 sheet라는 배열에 담겨 있다. 실제로 vue 에서 get, set 할수 있는 Function은 hotInstance에 있다 (Handsontable API에서 말하는 core 부분이 hotInstance 이다.)
				let scode = common.find_sid_code(this.sampleHeader, 'sampleid');
				let divcode = common.find_sid_code(this.sampleHeader, 'divisionidx');
				let recode = common.find_sid_code(this.sampleHeader, 'reexpidx');

				let i7IdCode = common.find_sid_code(this.sampleHeader, 'i7id');
				let i7SeqCode = common.find_sid_code(this.sampleHeader, 'i7seq');
				let i5IdCode = common.find_sid_code(this.sampleHeader, 'i5id');
				let i5SeqCode = common.find_sid_code(this.sampleHeader, 'i5seq');

				let last_plate = common.find_last_column(this.sampleHeader, 'plate');
				insert_row.forEach((a,b)=>{
					let sampleData = [];
					let pre_plate_m = '';
					sampleData.push(false);
					sampleData.push(this.sampleData.length+1);
					sampleData.push(a.sampleId);
					this.sampleHeader.forEach((c,d)=>{
						if (c.columnAttr === 'divisionidx') { //디비전 초기값 
							sampleData.push((common.isNull(a[c.columnCode])?0:a[c.columnCode]));
						} else if (c.columnAttr === 'reexpidx') {
							sampleData.push((common.isNull(a[c.columnCode])?0:a[c.columnCode]));
						} else {
							sampleData.push(a[c.columnCode]);
						}
				});
					sampleData["headerId"] = a.headerId
					sampleData.push(a.detailId);
					this.sampleData.push(sampleData);
				})
				// 데이터 변경 여부
				this.isWork++;
				// preSampleSetting 를 실행하는 이유는 데이터가 입력 되고 samples(buefy table)을 다시 render 하기 위하여 실행
				this.preSetting();
				this.preSampleSetting();
				this.isLoading = false;
			},
			/*
			* Sample Delete Column
			*/
			async sampleDelColumn(){
					this.$buefy.dialog.confirm({
					message: 'All unsaved sample divisions and reexperiments are deleted. Are you sure you want to delete?',
					size: 'is-medium',
					onConfirm: async () => {
						this.openLoading();
						const colCnt = this.$refs.sheet.hotInstance.countRows();
						const colArray = [];
						const divArray = [];
						const divDelArray = [];
						const backpre = [];
						var params = [];
						const allData = this.$refs.sheet.hotInstance.getData();
						let splitCount = 0;
						let del_detail = [];
						// Handsontable 데이터 삭제, 삭제 전 colArray 배열에 데이터를 미리 저장하여 addData있는 데이터를 splice 한다.
						for(let i=(colCnt-1); i >= 0; i--){
							if(this.$refs.sheet.hotInstance.getDataAtCell(i,0)){
								colArray[i] = this.$refs.sheet.hotInstance.getData(i,Number(this.$refs.sheet.hotInstance.countCols())-1,i,0)[0];
								this.$refs.sheet.hotInstance.alter('remove_row', i, 1);
							}
						}
						colArray.forEach(a=>{
							if(!common.isNull(a[a.length-1])) del_detail.push({detailId: a[a.length-1], sampleId: a[2], reexp: a[Number(common.find_sid_idx(this.sampleHeader, 'reexpidx'))+3]});
							this.$refs.sheet.hotInstance.getData().forEach((b, c)=>{
								if(a[2] == b[2]){
									divArray.push(c);
									divDelArray.push(b[last_plate_idx]);
									if(!common.isNull(a[a.length-1])) del_detail.push({detailId: a[a.length-1], sampleId: a[2],reexp:a[Number(common.find_sid_idx(this.sampleHeader, 'reexpidx'))+3]});
								}
							});
							
						});

						// 분할 정보 삭제
						divArray.sort();
						divArray.reverse();
						divArray.sort().forEach(a=>{
							this.$refs.sheet.hotInstance.alter('remove_row', a, 1)
							})

						// addData splice를 위하여 colArray sort 내림 차순 정렬 // addData는 검체(sample)의 중복 체크를 위한 배열
						colArray.sort(function(a, b){
							return a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0;
						});
						// addData splice를 위하여 addData sort 오름 차순 정렬
						this.addData.sort(function(a, b){
							return b - a;
						});

						let noDelArr = [];
						// addData splice
						for(let i in colArray){
							for(let j in this.addData){
								if(!common.isNull(colArray[i][colArray[i].length-1])){
									if(colArray[i][colArray[i].length-1] === this.addData[j].detailId) {this.addData.splice(j,1);}
								}else{
									if(colArray[i][2] === this.addData[j].sampleId)  {this.addData.splice(j,1);}
								}
							}
						}
						// 삭제 후 No의 Numbering 재설정 (속도 저하 - 20.06.25 (변경)) , Plate well 위치 변경 포함
						var noChgArr = this.$refs.sheet.hotInstance.getData();
						for(let i = 0; i < this.$refs.sheet.hotInstance.countRows(); i++){
							noChgArr[i].splice(1, 1, Number(i)+1);
						}
						if(del_detail.length > 0){
							const params = {'samples':del_detail, 'mid': this.properties.mid};
							this.$axios.patch(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+'/backpre', params).then(res=>{
							}).catch(err=>{console.log(err)})
						}
						this.$refs.sheet.hotInstance.loadData(noChgArr)

						// // this.checkedRowData = []
						this.classifyPreDefaultData();
						this.rendertab();
						this.isLoading = false;
					},
					onCancel: () => {
						this.isLoading = false;
						return false;
					}
				});
				this.isWork++;
			},
			/*
			* Plating Data Check All
			*/
			async checkAll(){
				const checkRow = this.$refs.sheet.hotInstance.getData();
				if(this.isCheckAll){
					this.isCheckAll = false;
				}else{
					this.isCheckAll = true;
				}
				this.sampleData.forEach(a => {
					a[0] = this.isCheckAll;
				});
				this.rendertab();
			},
			/*
			* Plating Data Change Arrary Insert
			*/
			async changeData(source){
				if(this.$refs.sheet.hotInstance){
					this.sampleChangeData = this.$refs.sheet.hotInstance.getData();
				}
				if(arguments[1] === 'edit' || arguments[1] === 'Autofill.fill'){ //문제 없음
					//arguments[0][0][3] => 입력값 arguments[0][0][0] => rownum
					if(arguments[0][0][3] != arguments[0][0][0]){ //DNA에서는 일로 탐
						this.boolChange = true;
					}else{
						if (Number(arguments[0][0][1]) > 2) {
							if (this.defaultSampleData) {
								if(arguments[0][0][3] != this.defaultSampleData[arguments[0][0][0]][Number(arguments[0][0][1])-1]){
									this.boolChange = true;
								}else{
									this.boolChange = false;
								}
							} else {
								this.boolChange = true;
							}
						} else {
							 this.boolChange = true;
						}
						
					}
				} else if (arguments[1] === 'loadData') { //sample add 후 아무 동작 안하고 save할시에 
					if (this.sampleChangeData) {
						if (arguments[0]) {
							this.boolChange = true;
						}
					}
				}

				if(this.isWork > 0) this.boolChange = true;

            },
            async csvExport(){
                common.sampleSheetExport(this.resultHeader,this.headerData.samples,this.headerData,this.sampleHeader)
            },
		 /*
		 * Plating & Samples Create data
		 */
		async createData(evt, action){
			if (evt) {
				this.openLoading();
			}
			var params = [];
			var sendKey = '';
			var sendValue = '';
			var changeData = [];
			var thisData = [];
			let wellList = [];
			var sidx = 0;	
			var myNum = 2
			for(let i in this.sampleData){
			   
			  	for(let j in this.sampleData[i]){
				  	if(j == 2){
					 // set sample : detail id 
						changeData.sid = this.sampleData[i][j];
				  	} else if(j > 2){
						if (common.isNull(this.sampleHeader[Number(j-3)])) {
							changeData.detailId = this.sampleData[i][j];
						} else {
							changeData[this.sampleHeader[Number(j-3)].columnCode] = this.sampleData[i][j];
						}
					} else if(j == "headerId")	{
                            changeData.headerId = this.sampleData[i][j];
					}
				}
				thisData.push($.extend(true, {}, changeData));
				changeData = [];
			}
			
			params = { 
				'msid': this.msid,
				'uid': this.properties.uid,
				'ssid': this.ssid,
				'samples': thisData,
				'preStatus' : common.preStatus(this.properties.mid,this.menuData),
				'preStatusA' : common.preStatus(this.properties.mid,this.menuData)
			}
			for (let i in this.resultHeader) {
				sendKey = this.resultHeader[i].columnCode;
				sendValue = this.headerData[this.resultHeader[i].columnCode];
				if(this.headerData[this.resultHeader[i].columnCode] != this.defaultHeaderData[this.resultHeader[i].columnCode]){
					this.boolChange = true;
				}

				if(sendValue){
					params[sendKey] = sendValue;
				}
			}

			// let requiredHeader = common.findRequiredByHeader(this.resultHeader) //리스트 필수값

			// for (let i in requiredHeader) { //필수값 벨리데이션
			// 	let check = Object.keys(params).find(item => item == requiredHeader[i].columnCode);
			// 	if (!check) {
			// 		this.$buefy.dialog.alert({
			// 			message: 'Please Enter '+ requiredHeader[i].columnName,
			// 			size: 'is-medium',
			// 			type: 'is-danger'
			// 		})
			// 		this.isLoading = false;
			// 		return false;
			// 	}
			// }

			// 데이터 변경이 있는 경우에만 저장
			if(this.boolChange){
				this.$axios.post(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params)
				.then(res=>{
					sessionStorage.setItem('uid',res.data.uid);
					this.properties.uid = res.data.uid;
					this.isLoading = false;
					this.boolChange = false;
					this.$router.go({name:this.$route.name});
				})
				.catch(err=>{
					if(err){
						this.$buefy.dialog.alert({
							message: 'The system failed and the save failed. Please contact your system administrator.',
							size: 'is-medium',
							type: 'is-danger'
						})
					}						
					console.log(err)
				});
			} else {
				this.isLoading = false;
				this.$buefy.dialog.alert({
					message: 'No data has been changed. Can not save.',
					size: 'is-medium',
					type: 'is-danger'
				})
				
				return false;
			}
		},
		async deleteData() {
			this.$buefy.dialog.confirm({
				message: 'Would you like to delete?',
				size: 'is-medium',
				onConfirm: async () => {
					const colCnt = this.$refs.sheet.hotInstance.countRows();
					const deleteArr = [];
					const delData = [];
					let params = [];
					for(let i=0; i < Number(colCnt); i++){
						deleteArr[i] = this.$refs.sheet.hotInstance.getData(i,Number(this.$refs.sheet.hotInstance.countCols())-1,i,0)[0];
					}
					for (let i in deleteArr) {
						let del = {
							'sampleId'	: deleteArr[i][2],
							'detailId'	: deleteArr[i][Number(this.$refs.sheet.settings.columns.length)-1],
						}
						delData.push(del);
					}

					params = {'delData':delData, 'hId':this.properties.uid, 'detailflag': true};
					this.$axios.patch(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+'/delete', params)
					.then(res=>{
						if (res.data) {
							this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, task:this.properties.task, type:'list'}});
						}
					})
				
				},
				onCancel: () => {
					this.isLoading = false;
					return false;
				}
			});
		},
		async dialogHandler(event){
			let samples = [];
			//선택 샘플 추출
			for (let i of this.sampleData) {
				if (i[0]) {
					samples.push(i[2]);
				}
			}
			if (samples.length > 0) {
				if (event === 'report') 
                	this.reportDialog = true;
				else if (event === 'confirm') this.confirm();
				return false;
			} else {
				this.$buefy.dialog.alert({
					message: 'Please select a sample',
					size: 'is-medium',
					type: 'is-danger'
				})
				return false;
			}
		},
		async confirm() {
			this.$buefy.dialog.confirm({
				message: 'Would you like to confirm?',
				size: 'is-medium',
				onConfirm: async () => {

					let samples = [];
					//선택 샘플 추출 (0: check(boolean), 2: sampleid)
					for (let i of this.sampleData) {
						if (i[0])
							samples.push(i[2]);
					}
					let params = {
						samples,
						uid: this.properties.uid,
					};
					
					this.$axios.patch(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+'/status', params)
					.then(res=>{
						// sessionStorage.setItem('uid',res.data.uid);
						// this.properties.uid = res.data.uid;
						// this.isLoading = false;
						// this.boolChange = false;
						this.$router.go({name:this.$route.name});
					})
					// sessionStorage.removeItem('uid');
					// this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list', task:this.properties.task}});
				},
				onCancel: () => {
					return false;
				}
			});
		}, 
		async createReport() {
			let samples = [];
			//선택 샘플 추출 (0: check(boolean), 2: sampleid)
			for (let i of this.sampleData) {
				if (i[0]) {
					samples.push(i[2]);
				}
			}
			this.reportDialog = false;
			this.isLoading = true;

			// python 과 backend 에서 통신이 나음 (ColumnCode)
			let params = [];
			params = {
				"uid": this.properties.uid,
				"samples": samples,
			};
			let request = {"params": params};
			try {
				const url = `${this.$apiHost}/${this.$route.name.substring(0, this.$route.name.indexOf('_'))}/report`;
				const report = await this.$axios.get(url, request);
				this.isLoading = false;
				window.open(report.data);

			} catch (error) {
				console.log(error);
			}
		},
		/*
		* List page Move (리스트 목록 페이지 이동)
		*/
		goPage() {
			if(this.boolChange){
				this.$buefy.dialog.confirm({
					message: 'You have changed data. Would you like to leave?',
					size: 'is-medium',
					onConfirm: async () => {
						sessionStorage.removeItem('uid');
						this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list', task:this.properties.task}});
					},
					onCancel: () => {
						return false;
					}
				});
			}else{
				this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list', task:this.properties.task}});
			}
		},
		/*
		* buefy 테이블 현재 토글 디테일 창 열기
		*/
		toggle(row) {
			// 본인 토글 창이 열려있을때 창 닫기.. b-table 설정에 defaultOpenedDetails 배열은 현재 열린 창이 입력 되도록 되어 있음
			if(row.id === this.defaultOpenedDetails[0]){
			this.defaultOpenedDetails = []
			}else{ // 토글 창이 닫혀있을때 실행
			this.$refs.table.toggleDetails(row);
			this.defaultOpenedDetails = [row.id]
			}
			this.preSampleSetting();
		},
		/*
		* buefy 테이블 이전 토글 디테일 창 닫기 b-table 설정에 toggle 창 실행 시 이전 창은 닫히고 현재 선택 창이 열리도록 설정 되어 있음
		*/
		closeAllOtherToggle(row, index) {
			this.defaultOpenedDetails = []
			this.defaultOpenedDetails = [row.id]
		},
		
		/*
		* handsontable 문제가 있음 화면에 정상 랜더링이 아니면 화면이 나타나지 않음 그래서 setTimeout으로 2번 실행하여 랜더링 위치 잡는 함수
		*/
		rendertab() {
			// height 는 Hansontable이 height를 설정하지 않으면 Handsontable event 가 일어날때마다 계속 height가 무한정 늘어남
			// hotInstance의 updateSettings를 사용하여 기본 setting 값을 수정 한다.
			if(this.sampleData.length > 0){
				// plate 위치 변경 확인
				// let plate_chg = common.plateDataChange(Number(last_plate_idx)+3, this.sampleData);
				// plate_chg.forEach((a)=>{
				// 	this.sampleData[a[0]][Number(last_plate_idx)+3] = a[1]
				// });
				// handsontable render 기본 높이 구하기
				let height = (Number(this.height) - 345)+'px';
				this.$refs.sheet.hotInstance.updateSettings({height:height})
				// Handsontable 문제로 화면이 전환될때 기존에 출력 화면 위치를 잃어 버림, render를 한번 사용하면 화면에 출력될 디자인만 그린다
				// 출력 위치까지 잡으려면 render를 한번 더 사용해야한다. 연속으로 render를 하면 되지 않아서 setTimeout으로 약간의 시간차를 두고 render 실행한다
				// 하지만 tab를 사용할 때 데이터가 있다면 4줄정도만 나오게 된다. 이부분 때문에 동일한 render를 무려 8번이나 실행했다.
				// 그렇다고 setTimeout의 시간을 늘려 render 시간을 해주는건 헛수고 이다.
				// 짧은 시간 반복 횟수가 중요 함 (10*20 timeout이 가장 적절하며, 20미만은 render 안됨)
				const rows = (this.$refs.sheet.hotInstance.countRows() / 10) + 1;
				for(let i = 0; i < rows ;i++){
					setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
					// this.$refs.sheet.hotInstance.render();
				}
			}
		},
		/*
		* confirm Data page Move
		*/
		async confirmData() {
			if (this.boolChange) {
				this.createData(false, 'confirm');
				return false;
			} 
			if (this.properties.uid) {
				
				this.$buefy.dialog.confirm({
					message: 'Are you sure you want to confirm?',
					size: 'is-medium',
					onConfirm: async () => {
						for (let i in this.sampleData) {
							if (common.isNull(this.sampleData[i][common.findIdxByAttr(this.sampleHeader, 'platingresultcode')+3])) {
								this.$buefy.dialog.alert({
									message: 'Please enter the result.',
									size: 'is-medium',
									type: 'is-danger'
								})
								return false;
							}
						}
						this.openLoading();
				
						const uid = this.properties.uid;
						const mid = this.properties.mid
						let colCnt = this.$refs.sheet.hotInstance.countRows();
						let detailIds = [];
						for(let i=0; i < Number(colCnt); i++){
							detailIds.push(this.$refs.sheet.hotInstance.getDataAtCell(i,this.sampleData[i].length-1));
						}
						this.$axios.patch(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/confirm', {
						uid, detailIds, mid
						})
						.then((res) => {
							sessionStorage.setItem('uid',uid);
							this.isLoading = false;
							this.$router.push({name:'platinges_completion',params:{mid:this.properties.mid,uid:uid,type:'detail', task:this.properties.task}});
						});
					},
					onCancel: () => {
						this.isLoading = false;
						return false;
					}
				});
			} else {
				this.createData(false, 'confirm');
				return false;
			}
		},
		/*
		* confirm Data page Move
		*/
		async classifyWorkChange(mid) {
			if(this.premid != mid){
				this.premid = mid;
				this.re_expid = mid;
				this.classifyPreDefaultData(true);
			}
		},
		/*
		* page Loading bar
		*/
		openLoading() {
			this.isLoading = true
			// setTimeout(() => {
			// 	this.isLoading = false
			// }, 10 * 100)
		},
		/*
		* Handsontable Reception no cell render
		*/
		anchorRenderer(instance, td, row, col, prop, value, cellProperties) {
			Handsontable.renderers.TextRenderer.apply(this, arguments);
			let anchor = null;
			anchor = document.createElement("a");
			anchor.href='#modal5'
			anchor.setAttribute("data-toggle","modal");
			anchor.text = value;
			const sendId = this.sendId;
			const sampleData = this.headerData.samples;
			anchor.onclick = function() {
				sendId(sampleData[row].id);
			};
			Handsontable.dom.empty(td);
			td.appendChild(anchor);
		},
		/*
		* Handsontable Reception no cell render
		*/
		figureRenderer(instance, td, row, col, prop, value, cellProperties) {
			Handsontable.renderers.TextRenderer.apply(this, arguments);
			let columnData = this.sampleHeader[prop-3]; 
			if (columnData.limitMinInEquality == '<' && columnData.limitMaxInEquality == '<') {
				if (columnData.limitMinvalue < Number(value) && Number(value) < columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '<=' && columnData.limitMaxInEquality == '<=') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '<=' && columnData.limitMaxInEquality == '<') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '<' && columnData.limitMaxInEquality == '<=') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '>') {
				if (columnData.limitMinvalue < Number(value) && Number(value) < columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '>=') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '>') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '>=') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '<') {
				if (columnData.limitMinvalue < Number(value) && Number(value) < columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '<=') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else  if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '<') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				}
			} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '<=') {
				if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
				} else {
					td.style.color = '#FA5858';
					td.style.backgroundColor = '#FBEFF2';
				} 
			} 
		},
		/*
		* Handsontable Reception no click is chat.vue send uuid
		*/
		sendId(id){
			bus.$emit("receptid", id);
		},
		onScroll(e) {
			if(window.top.scrollY > 360) $('.ht_clone_top').css('top', (window.top.scrollY-330)+'px');
			else $('.ht_clone_top').css('top', '0px');
		},
	},
	computed: {
		sheetSettings() {
			let settings = this.$store.getters.sheetSettings;
			return settings;
		},
		preSampleSetting() {
			return this.classifyPreSampleHeader;
		},
		preSetting() {
			return this.classifyPreHeader;
		},
	},
	watch: {
		checkedRows: function() {
			// 상위 테이블 선택 한경우 this.checkedRowData에 무조건 Insert
			const validVisibleData = this.$refs.table.visibleData.filter((row, idx) => {
				if(this.$refs.table.isRowChecked(row)){
					this.checkedRowData = this.checkedRowData.concat(common.makeData(this.preDefaultSampleData[idx], 1, this.addData));
					common.a_overlap_c(this.checkedRowData);
				}else{
					let data = common.makeData(this.preDefaultSampleData[idx], 1, this.addData);
					data = data.filter((s_row, s_idx)=>{
						for(let i in this.checkedRowData){
							if(this.checkedRowData[i].hasOwnProperty('detailId') && s_row.hasOwnProperty('detailId')){
								if(this.checkedRowData[i].detailId === s_row.detailId){
									this.checkedRowData.splice(i, 1);
								}
							}else{
								if(this.checkedRowData[i].sampleId === s_row.sampleId){
									this.checkedRowData.splice(i, 1);
								}
							}

						}
					});
				}
			});
			// 하위 테이블 데이터 새로 고침
			this.classifyPreSampleData();

		},
		sampleCheckedRows: function(){
			// 하위 데이터가 모조건 전체 선택인 경우 실행 (현재 기준 19.08.29 15시)
			for(let i in this.$refs.table.visibleData){ 
				// 하위 sample 데이터의 갯수에 따른 상위 데이터 체크 박스 해제 기능
				if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[i])){ // 상위 테이블 체크 여부 확인
					if(this.preSampleData.length > this.sampleCheckedRows.length){ // sample 데이터와 sample 체크 데이터 비교 조건
						for(let i in this.$refs.table.newCheckedRows){ // 상위 체크 데이터 loop
							if(this.preSampleData[0].gid === this.$refs.table.newCheckedRows[i].id){ // sample 데이터의 gid와 상위 체크 데이터 같은 경우 상위 데이터 splice
								this.$refs.table.newCheckedRows.splice(i, 1);
							}
						}
					}
				}
				// 하위 테이블 체크 박스 모두 선택 인 경우 상위 테이블의 체크 박스 추가 기능
				if(event.path[7].id === 'preSampleTable'){ // 하위 체크 박스 선택 여부 확인 (event로 구분했음 향후 변경 필요 함)
					if(this.$refs.sampleTable.isAllChecked){ // 하위 테이블의 체크 박스 전체 선택 여부 확인
						if(this.preSampleData[0].gid === this.$refs.table.visibleData[i].id){ // sample 데이터와 sample 체크 데이터 비교 조건
							this.$refs.table.newCheckedRows.push(this.$refs.table.visibleData[i]); // 없는 경우 추가
						}
					}
				}
			}
			// Add 데이터 생성
			this.checkedRowData = this.checkedRowData.concat(this.sampleCheckedRows); // 전체 넣기
			common.a_overlap_c(this.checkedRowData); // 중복 제거 common make function
			if(this.sampleCheckedRows.length != this.preSampleData.length){ // 전체 아닌 경우 Add 데이터 생성
				if(event.path[7].id === 'preSampleTable'){ // preSampleTable의 이벤트를 체크 (단 event의 path값 변경되면 수정 해주어야 함)
					let checkedIdx = [];
					this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
						this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
							// detailId key가 없는 경우 비교
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									if(!this.$refs.sampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
										checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
									}
								}
							}else{
								if(a.sampleId === c.sampleId){
									if(!this.$refs.sampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
										checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
									}
								}
							}
							return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return
					});
					checkedIdx.sort((a,b)=>{return b - a}) // 해당 변수를 역순으로 sort
					if(checkedIdx.length > 0){ // 이부분이 중요. 아래 조건문의 splice 는 해당 배열 값을 삭제 한다. 단 순차적으로 삭제하면 삭제한 row가 없어져 에러가 난다 (아래 계속)
						for(let i in checkedIdx){ // (아래 계속) 그래서 역순으로 정렬하여 배열의 마지막 값 부터 삭제 한다. 간단하지만 꼭 기억해야함.
							this.checkedRowData.splice(checkedIdx[i], 1);
						}
					}
				}
			}
			// // 개별 선택 체크 박스를 true로 바꾸는 작업
			if(this.sampleCheckedRows.length === 0 && this.checkedRowData.length > 0){
				this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
					this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
						if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
							if(a.detailId === c.detailId){
								this.sampleCheckedRows.push(c);
							}
						}else{
							if(a.sampleId === c.sampleId){
								this.sampleCheckedRows.push(c);
							}
						}
						return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
					});
					return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return..
				});
			}
		},
		preHeader: function(){
		},
	},
}

</script>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Result/DetailForm.vue